import { NavLink, Outlet, useLocation, useNavigate, } from "react-router-dom";
import { useEffect } from "react";
import { RequireAuth, useAuth } from "../../auth/AuthProvider";
import Footer from "../footer";
import Header from "../header";
import heroImg from "../../assets/images/hero.png"
import { confirmAlert } from "react-confirm-alert";
import { useDispatch, useSelector } from "react-redux";
import airtable from "../../lib/airtables";
import { setAnnouncements, setAnnouncementsUnread, setMessagesUnread } from "../../redux/app/actions";
import { Announcement } from "../../lib/airtables/models";
import { getHasUnreadAnnouncements, getLastSeenAnnouncementAt } from "../../lib/announcements/status";
import { teacherFieldIds } from "../../lib/airtables/tables/Teachers";
import { ARTIST_AMBASSADOR_SCHEDULING_ENABLED } from "../../helpers/constants";

export function MainLayout() {
  const { user, logout } = useAuth();
  const { announcements, hasUnreadAnnouncements, hasUnreadMessages } = useSelector((state: any) => state.app);
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const dashboard = location.pathname === "/app/dashboard";
  const isArtist =
    user?.[teacherFieldIds.artist] === "Yes";
  const signOut = () => {
    confirmAlert({
      title: "Sign out",
      message: "Are you sure you want to sign out?",
      buttons: [{
        label: `OK`,
        onClick: () => logout()
      },
      {
        label: "Cancel",
        onClick: () => { }
      }]
    });
  }

  useEffect(() => {
    if (!user || isArtist || (announcements && announcements.length)) return;

    airtable.announcements.getItemsForToday(6).then(
      (res: Announcement[]) => {
        dispatch(setAnnouncements(res));
        const lastSeen = getLastSeenAnnouncementAt(user);
        dispatch(setAnnouncementsUnread(getHasUnreadAnnouncements(res, lastSeen)));
      }
    )
  }, [announcements, dispatch, isArtist, user]);

  useEffect(() => {
    if (!ARTIST_AMBASSADOR_SCHEDULING_ENABLED || !user || !isArtist) return;
    if (location.pathname.startsWith("/app/artist-ambassador-scheduling")) return;

    navigate("/app/artist-ambassador-scheduling/artist-review", { replace: true });
  }, [isArtist, location.pathname, navigate, user]);
    
  // this effect is used to check for the user's email, then check if the user has any unread messages. If we don't have the user's email, we assume they are not logged in and set hasUnreadMessages to false.
  // If we don't have the users email we just say that they don't have any messages so this loads without errors.
  
  useEffect(() => {
    const recipientEmail = user?.[teacherFieldIds.email];
    if (!recipientEmail) {
      dispatch(setMessagesUnread(false));
      return;
    }

    airtable.messages.getUnreadForRecipientEmail(recipientEmail).then((items) => {
      dispatch(setMessagesUnread(items.length > 0));
    }).catch(() => {
      dispatch(setMessagesUnread(false));
    });
  }, [dispatch, user]);

  return (
    <RequireAuth>
      <div className="bg-gray-100 flex flex-col h-full">
        <Header />
        <div className="flex-1">
          <div className="hero-image">
            <img src={heroImg} alt="dwf dashboard hero" />
          </div>
          <div className="nav-bar">
            <div className="max-w-7xl h-full mx-auto flex justify-between items-center">
              <p>{user ? `Welcome, ${user?.[teacherFieldIds.name] || ""}!` : "Welcome!"}</p>
              <div className="flex items-center gap-4">
              {!dashboard && ( <NavLink to ="/app/dashboard" className="nav-link">Dashboard</NavLink>
                )}
              {user ? 
                      (<NavLink 
                      to ="/app/messages" 
                        className={'nav-link nav-link-with-badge ${hasUnreadMessages ? "font-bold" : ""}' .trim()}
                        >
                            Messages
                            {hasUnreadMessages ? (
                            <span className="nav-link-badge" aria-label="Unread messages" />
                            ) : null}
                            </NavLink> ) : null}
                {!isArtist ? (

                  <div>

                    <NavLink
                     to="/app/announcements"
                      className={`nav-link nav-link-with-badge ${hasUnreadAnnouncements ? "font-bold" : ""}`.trim()}
                    >
                      Announcements
                      {hasUnreadAnnouncements ? (
                       <span className="nav-link-badge" aria-label="Unread announcements" />
                      ) : null}
                   </NavLink>
                  </div> 
                ) : null}
                {user ? (
                  <span
                    onClick={() => signOut()}
                    className="nav-link"
                  >Sign out</span>
                ) : (
                  <NavLink to="/login" className="nav-link">Log in</NavLink>
                )}
              </div>
            </div>
          </div>
          <Outlet />
        </div>
        <Footer />
      </div>
    </RequireAuth>
  )
}
